(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lmc_experience"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('lmc-experience')){
  customElements.define('lmc-experience',class extends HTMLElement{
    connectedCallback(){
      if(this.lifecycle)return;
      this.lifecycle=new AbortController();this.mount();
      document.addEventListener('shopify:section:load',()=>{this.unmount();this.mount()},{signal:this.lifecycle.signal});
    }
    mount(){
      this.header=document.querySelector('.lmc-header');
      if(!this.header||this.header.hasAttribute('data-lmc-polished'))return;
      this.menu=this.header.querySelector('.lmc-mobile-menu');
      this.summary=this.menu?.querySelector('summary');
      if(!this.menu||!this.summary)return;
      this.events=new AbortController();const opts={signal:this.events.signal};
      this.mobile=matchMedia('(max-width:749px)');
      this.hover=matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)');
      this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
      this.timers=new Map();this.animations=[];
      this.header.setAttribute('data-lmc-polished','');
      this.header.addEventListener('keydown',e=>{if(e.key==='Escape'&&!e.defaultPrevented&&this.mobile.matches&&this.menu.open){e.preventDefault();this.setMenu(false,true)}},opts);
      document.addEventListener('pointerdown',e=>{if(!this.header.contains(e.target))this.setMenu(false)},opts);
      this.header.addEventListener('focusout',e=>{if(e.relatedTarget&&!this.header.contains(e.relatedTarget))this.setMenu(false)},opts);
      this.header.addEventListener('click',e=>{if(e.target.closest('.lmc-nav a'))this.setMenu(false)},opts);
      this.header.querySelector('input[name="q"]')?.addEventListener('focus',()=>this.setMenu(false),opts);
      this.menu.addEventListener('toggle',()=>{if(this.menu.open)this.closeSearch();else this.closeDetails()},opts);
      this.mobile.addEventListener('change',()=>this.setMenu(false),opts);
      for(const detail of this.header.querySelectorAll('.lmc-desktop-navigation details')){
        detail.addEventListener('mouseenter',()=>{if(!this.hover.matches)return;clearTimeout(this.timers.get(detail));this.timers.set(detail,setTimeout(()=>{if(this.hover.matches)detail.open=true},140))},opts);
        detail.addEventListener('mouseleave',()=>{clearTimeout(this.timers.get(detail));if(!this.hover.matches||detail.contains(document.activeElement))return;this.timers.set(detail,setTimeout(()=>{detail.open=false},220))},opts);
        detail.addEventListener('focusout',e=>{if(!detail.contains(e.relatedTarget)&&!detail.matches(':hover'))detail.open=false},opts);
        detail.addEventListener('toggle',()=>{if(detail.open)this.closeSearch()},opts);
      }
      this.group=this.header.closest('#header-group');
      if(this.group&&this.dataset.sticky==='true'){
        this.group.classList.add('lmc-sticky-enabled');
        const measure=()=>{const a=this.header.querySelector('.lmc-announcement')?.getBoundingClientRect().height||0;this.group.style.setProperty('--lmc-announcement-height',`${a}px`);document.documentElement.style.setProperty('--lmc-scroll-offset',`${Math.ceil(this.header.getBoundingClientRect().height-a+24)}px`)};
        measure();
        if('ResizeObserver'in window){this.resizeObserver=new ResizeObserver(measure);this.resizeObserver.observe(this.header)}
      }
      if(this.dataset.motion==='true'&&!this.reduced.matches&&'IntersectionObserver'in window){
        this.observer=new IntersectionObserver(entries=>{for(const entry of entries){if(!entry.isIntersecting)continue;this.observer.unobserve(entry.target);if(this.reduced.matches||typeof entry.target.animate!=='function')continue;this.animations.push(entry.target.animate([{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'none'}],{duration:360,easing:'cubic-bezier(.22,.61,.36,1)'}))}},{threshold:.08});
        document.querySelectorAll('.lmc-category-card,.lmc-editorial-inner,.lmc-room-card').forEach(el=>{if(el.getBoundingClientRect().top>=window.innerHeight)this.observer.observe(el)});
        this.reduced.addEventListener('change',()=>{if(this.reduced.matches){this.observer?.disconnect();this.animations.forEach(a=>a.cancel())}},opts);
      }
    }
    closeSearch(){const search=this.header?.querySelector('lmc-search-suggest');if(typeof search?.close==='function')search.close()}
    closeDetails(){this.timers?.forEach(timer=>clearTimeout(timer));this.timers?.clear();this.header?.querySelectorAll('.lmc-nav details[open]').forEach(d=>{d.open=false})}
    setMenu(open,focus=false){if(!this.menu)return;this.menu.open=Boolean(open&&this.mobile.matches);if(!this.menu.open)this.closeDetails();if(focus)this.summary.focus()}
    unmount(){
      if(!this.events)return;
      this.setMenu(false);this.events.abort();this.events=null;
      this.observer?.disconnect();this.resizeObserver?.disconnect();this.animations?.forEach(a=>a.cancel());
      this.header?.removeAttribute('data-lmc-polished');
      this.group?.classList.remove('lmc-sticky-enabled');this.group?.style.removeProperty('--lmc-announcement-height');
      document.documentElement.style.removeProperty('--lmc-scroll-offset');
    }
    disconnectedCallback(){this.lifecycle?.abort();this.lifecycle=null;this.unmount()}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmc_header"]) return;
  try {
    
if(!customElements.get('lmc-navigation')){customElements.define('lmc-navigation',class extends HTMLElement{connectedCallback(){if(this.onToggle)return;this.onToggle=(e)=>{if(e.target.tagName==='DETAILS'&&e.target.open){this.querySelectorAll('details[open]').forEach(d=>{if(d!==e.target)d.open=false})}};this.onOutside=(e)=>{if(!this.contains(e.target))this.querySelectorAll('details[open]').forEach(d=>d.open=false)};this.onKey=(e)=>{if(e.key==='Escape'){const d=this.querySelector('details[open]');if(d){d.open=false;d.querySelector('summary').focus()}}};this.addEventListener('toggle',this.onToggle,true);document.addEventListener('click',this.onOutside);this.addEventListener('keydown',this.onKey)}disconnectedCallback(){this.removeEventListener('toggle',this.onToggle,true);document.removeEventListener('click',this.onOutside);this.removeEventListener('keydown',this.onKey);this.onToggle=null}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmc_product_detail"]) return;
  try {
    
document.querySelectorAll('[data-lmc-pdp]').forEach((root) => {
  if (root.dataset.lmcReady === 'true') return;
  root.dataset.lmcReady = 'true';

  const mainImage = root.querySelector('.lmc-pdp__main-image');
  const zoomImage = root.querySelector('.lmc-pdp__zoom-image');
  const dialog = root.querySelector('[data-lmc-dialog]');
  const quantity = root.querySelector('[data-lmc-quantity]');
  const minus = root.querySelector('[data-lmc-minus]');
  const plus = root.querySelector('[data-lmc-plus]');
  const variant = root.querySelector('[data-lmc-variant]');
  const price = root.querySelector('[data-lmc-price]');
  const compare = root.querySelector('[data-lmc-compare]');
  const availability = root.querySelector('[data-lmc-availability]');
  const sku = root.querySelector('[data-lmc-sku]');
  const add = root.querySelector('[data-lmc-add]');
  const availabilityReview = root.dataset.availabilityReview === 'true';

  const swapImage = (el) => {
    if (!mainImage || !el || !el.dataset.src960) return;
    const src640 = el.dataset.src640 || el.dataset.src960;
    const src960 = el.dataset.src960;
    const src1400 = el.dataset.src1400 || src960;
    mainImage.src = src960;
    mainImage.srcset = src640 + ' 640w, ' + src960 + ' 960w, ' + src1400 + ' 1400w';
    mainImage.alt = el.dataset.alt || el.dataset.imageAlt || '';
    if (zoomImage) {
      zoomImage.src = src1400;
      zoomImage.srcset = mainImage.srcset;
      zoomImage.alt = mainImage.alt;
    }
  };

  root.querySelectorAll('[data-lmc-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      root.querySelectorAll('[data-lmc-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      swapImage(thumb);
    });
  });

  if (minus && quantity) {
    minus.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
  }

  if (plus && quantity) {
    plus.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });
  }

  if (variant) {
    variant.addEventListener('change', () => {
      const option = variant.options[variant.selectedIndex];
      const isAvailable = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.classList.toggle('is-hidden', !option.dataset.compare);
      }
      if (sku) sku.textContent = option.dataset.sku || '—';
      if (availability) {
        availability.textContent = availabilityReview ? 'Availability being verified' : (isAvailable ? 'In stock' : 'Sold out');
      }
      if (add) {
        add.disabled = !isAvailable;
        add.textContent = isAvailable ? 'Add to cart' : 'Sold out';
      }
      if (option.dataset.image960) {
        swapImage({
          dataset: {
            src640: option.dataset.image640,
            src960: option.dataset.image960,
            src1400: option.dataset.image1400,
            alt: option.dataset.imageAlt
          }
        });
      }
    });
  }

  const openZoom = root.querySelector('[data-lmc-zoom-open]');
  const closeZoom = root.querySelector('[data-lmc-zoom-close]');
  if (openZoom && dialog) openZoom.addEventListener('click', () => dialog.showModal());
  if (closeZoom && dialog) closeZoom.addEventListener('click', () => dialog.close());
  if (dialog) {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
